import React from 'react';
import { ChartsAxisContentProps } from '@mui/x-charts';

import { colors, styled } from 'core/styles';

import { xTickFormatter, priceFormatter } from './helpers';

export function ChartTooltip(props: ChartsAxisContentProps) {
  const { dataIndex, series, axisValue } = props;
  const timestamp = axisValue;

  if (typeof dataIndex !== 'number' || !(timestamp instanceof Date)) {
    return null;
  }

  const marketPrice = series[0].data[dataIndex];
  const oraclePrice = series[1].data[dataIndex];

  return (
    <Root>
      <TooltipLabel>{xTickFormatter(timestamp)}</TooltipLabel>
      {marketPrice && (
        <TooltipContent>Market: {priceFormatter(Number(marketPrice))}</TooltipContent>
      )}
      {oraclePrice && (
        <TooltipContent>Oracle: {priceFormatter(Number(oraclePrice))}</TooltipContent>
      )}
    </Root>
  );
}

const Root = styled('div')(() => ({
  padding: '4px 8px 6px 8px',
  background: colors.blackOpacity[8],
  backdropFilter: 'blur(20px)',
  borderRadius: 4,
  fontSize: 12,
}));

const TooltipLabel = styled('p')(() => ({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 12,
  margin: 0,
}));

const TooltipContent = styled('p')(() => ({
  fontSize: 12,
  margin: 0,
}));
